// Mobile Menu & Search
const hamburger = document.querySelector(".hamburger");
const searchToggle = document.querySelector(".header-icon--search");
const searchForm = document.querySelector("#mobile-search .search-form");
const searchBar = document.querySelector("#mobile-search .search-form input[type='text']");
const body = document.body;
// On click of burger icon
hamburger.addEventListener("click", function () {
    // Close mobile search if it's open
    searchToggle.classList.remove("is-active");
    body.classList.remove("mobile-search-open");
    searchForm.reset();
    // Toggle mobile menu
    hamburger.classList.toggle("is-active");
    body.classList.toggle("mobile-menu-open");
});

// On click of mobile search icon
searchToggle.addEventListener("click", function () {
    // Close mobile menu if it's open
    hamburger.classList.remove("is-active");
    body.classList.remove("mobile-menu-open");
    // Toggle mobile search
    searchToggle.classList.toggle("is-active");
    body.classList.toggle("mobile-search-open");
    searchForm.reset();
    searchBar.focus();
});
